export default "__VITE_ASSET__Bhvl214G__"